
import { ApiURLs } from "../../../constant/ApiUrls";
import { fetchData, } from "../../../services/api";







export const removedExpiredAdsLisitingRequest = (page = 1, pageSize = 10) => {

  return async (dispatch) => {

    const url = `${ApiURLs.REMOVED_EXPIRED_ADS}?limit=${pageSize}&offset=${page}`;

    // wait untill the data not received so getData function take data and url part
    dispatch({ "type": "GET_REMOVED_EXPIRED_ADS_REQUEST" });
    try {
      var removedExpiredAdsData = await fetchData(url);
      console.log(`response when we try to get sold ads   ${JSON.stringify(removedExpiredAdsData)}`)
      if (removedExpiredAdsData.status === 1) {
        dispatch({
          "type": "GET_REMOVED_EXPIRED_ADS_REQUEST_SUCCESS", "payload": removedExpiredAdsData.data.result || [],
          total: removedExpiredAdsData.data.total || 0,
        });

      } else {
        dispatch({ "type": "GET_REMOVED_EXPIRED_ADS_REQUEST_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "GET_REMOVED_EXPIRED_ADS_REQUEST_FAILED" });
      console.log(`error while try to get sold ads  ${error}`)
    }
  }
};



